import { Injectable } from "@angular/core";
import {
    ToastController,
    LoadingController,
    Platform,
    AlertController
} from "ionic-angular";

import { Market } from "@ionic-native/market";

@Injectable()
export class HelperServiceProvider {
    public loading: any;
    public isBusy: boolean;
    public redlofLoader: any;
    public unread_chat: number = 0;

    DEFAULT_DEPO_ID: any = null;
    DEFAULT_DEPO_NAME: any = null;

    constructor(
        private toastCtrl: ToastController,
        private alertCtrl: AlertController,
        private market: Market,
        public platform: Platform,
        public loadingCtrl: LoadingController
    ) {
        var defaultDepoName: any = localStorage.getItem("GP_DU_DEPO_NAME");
        var defaultDepoID: any = localStorage.getItem("GP_DU_DEPO_ID");

        if (defaultDepoID) {
            this.DEFAULT_DEPO_ID = defaultDepoID;
        }

        if (defaultDepoName) {
            this.DEFAULT_DEPO_NAME = defaultDepoName;
        }
    }

    user_img: any = null;
    has_internet: any = true;

    presentToast(message: string) {
        let toast = this.toastCtrl.create({
            message: message,
            duration: 6000,
            showCloseButton: true,
            closeButtonText: "dismiss",
            position: "bottom",
            cssClass: "toast_class"
        });

        toast.onDidDismiss(() => {});

        toast.present();
    }

    showLoader(message: string) {
        if (!this.loading) {
            this.loading = this.loadingCtrl.create({
                content: message
            });
            this.loading.present();
        }
    }

    dismissLoader() {
        if (this.loading) {
            this.loading.dismiss();
            this.loading = null;
        }
    }

    handleError(error) {
        var result = error["error"]["msg"].replace(/(<br>)/g, ", ");

        let toast = this.toastCtrl.create({
            message: result,
            duration: 3000,
            position: "bottom"
        });

        toast.onDidDismiss(() => {
            console.log("Dismissed toast");
        });

        toast.present();
    }

    getTheArrIndex(data, id) {
        if (data.length === 0) {
            return null;
        }
        var keepGoing = true;
        var keyVal = null;

        for (var i = 0; i < data.length; i++) {
            if (keepGoing) {
                if (parseInt(data[i].id) === parseInt(id)) {
                    keyVal = i;
                    keepGoing = false;
                }
            }
        }

        return keyVal;
    }

    clear() {
        this.user_img = null;
        this.has_internet = true;
    }

    updateTheApp(force_update, title, message) {
        let soft_update_close_disable = false;

        let buttons: any = [];

        let cancelBtn: any = {
            text: "Cancel",
            role: "cancel",
            cssClass: "cancel",
            handler: () => {
                console.log("Cancel clicked");
            }
        };

        let cstcls = "";

        if (force_update) {
            cstcls = "update_width";
        }

        let updateBtn: any = {
            text: "Update",
            cssClass: "update " + cstcls,
            handler: () => {
                this.forceUpdateAction();
            }
        };

        if (!force_update) {
            buttons.push(cancelBtn);
            soft_update_close_disable = true;
        }

        buttons.push(updateBtn);

        let alert = this.alertCtrl.create({
            title: title,
            cssClass: "alert_custom",
            enableBackdropDismiss: soft_update_close_disable,
            message: message,
            buttons: buttons
        });
        alert.present();
    }

    forceUpdateAction() {
        let self = this;

        try {
            this.market.open("in.gramophone.fieldapp");

            setTimeout(function() {
                self.platform.exitApp();
            }, 1000);
        } catch (err) {
            this.presentToast("There is problem opening the app in play store");
        }
    }
}



// WEBPACK FOOTER //
// ./src/common/services/helper.service.ts